// extracted by mini-css-extract-plugin
export default {"root":"ChangeIndicator_root_GFd2v","circle":"ChangeIndicator_circle_hQ2kT","cancel":"ChangeIndicator_cancel_zsE4A"};